import React, { Fragment, useState, useContext } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { useParams } from 'react-router-dom';
import { store } from './Tendering';
import { store as mainStore } from '../../../../../store';
import axios from '../../../../../api/axios';
import { makeStyles } from '@material-ui/core/styles';
import DriverProposeDialog from './DriverProposeDialog';
import FlagIcon from '@material-ui/icons/Flag';
import DeleteIcon from '@material-ui/icons/Delete';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import { Button, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {},
}));

const BiddersCommandsList = ({ driver, order, onClose, refetch }) => {
  const classes = useStyles();
  const { id: orderId } = useParams();
  const {
    showMessage,
    showError,
    state: {
      Props: { itemsCountPerPage },
    },
  } = useContext(mainStore);
  const {
    dispatch,
    actions: { fetchingDrivers, fetchingBidders },
    state: { readyDrivers },
  } = useContext(store);
  const [driverProposeD, setDriverProposeD] = useState(false);
  const [loadingActions, setLoadingActions] = useState({
    deleteUser: false,
    selectUser: false,
    deselectPropose: false,
    deselectDriver: false,
    confirmDriver: false,
  });
  var status;
  if (order?.drivers?.includes(driver._id)) status = 'confirmedDriver';
  else if (order?.driversSelected?.includes(driver._id))
    status = 'selectedDriver';
  else if (driver?.propose) status = 'driverProposed';
  else status = 'waitingForDriverBid';

  const handleSelectDriver = async () => {
    try {
      setLoadingActions({ ...loadingActions, selectUser: true });
      const {
        data: { messages, order },
      } = await axios.post(`/api/v1/admin/orders/tendering/sendToCustomer`, {
        orderId,
        driverId: driver._id,
      });
      showMessage(messages);
      dispatch({ type: 'ORDER', payload: order });
      onClose();
    } catch (error) {
      showError(error);
    } finally {
      setLoadingActions({ ...loadingActions, selectUser: false });
    }
  };

  const handleDeleteDriver = async () => {
    try {
      setLoadingActions({ ...loadingActions, deleteUser: true });
      const {
        data: { messages, order },
      } = await axios.post(`/api/v1/admin/orders/tendering/deleteDriver`, {
        orderId,
        driverId: driver._id,
      });
      showMessage(messages);
      dispatch({ type: 'ORDER', payload: order });
      await refetch();
      const drivers = await fetchingDrivers(orderId);
      dispatch({ type: 'DRIVERS', payload: drivers });
      onClose();
    } catch (error) {
      showError(error);
    } finally {
      setLoadingActions({ ...loadingActions, deleteUser: false });
    }
  };
  const handleDeselectPropose = async () => {
    try {
      setLoadingActions({ ...loadingActions, deselectPropose: true });
      const {
        data: { messages, order },
      } = await axios.post(`/api/v1/admin/orders/tendering/deselectPropose`, {
        orderId,
        driverId: driver._id,
      });
      showMessage(messages);
      dispatch({ type: 'ORDER', payload: order });
      onClose();
    } catch (error) {
      showError(error);
    } finally {
      setLoadingActions({ ...loadingActions, deselectPropose: false });
    }
  };
  const handleDeselectDriver = async () => {
    try {
      setLoadingActions({ ...loadingActions, deselectDriver: true });
      const {
        data: { messages, order },
      } = await axios.post(`/api/v1/admin/orders/tendering/deselectDriver`, {
        orderId,
        driverId: driver._id,
      });
      showMessage(messages);
      dispatch({ type: 'ORDER', payload: order });
      onClose();
    } catch (error) {
      showError(error);
    } finally {
      setLoadingActions({ ...loadingActions, deselectDriver: false });
    }
  };
  const handleConfirmDriver = async () => {
    try {
      setLoadingActions({ ...loadingActions, confirmDriver: true });
      const {
        data: { messages, order },
      } = await axios.post(`/api/v1/admin/orders/tendering/confirmDriver`, {
        orderId,
        driverId: driver._id,
      });
      showMessage(messages);
      dispatch({ type: 'ORDER', payload: order });
      onClose();
    } catch (error) {
      showError(error);
    } finally {
      setLoadingActions({ ...loadingActions, confirmDriver: false });
    }
  };
  const handleShowDriverProposeD = () => {
    setDriverProposeD(true);
  };
  const handleCloseDriverProposeD = () => {
    setDriverProposeD(false);
    onClose();
  };

  return (
    <Fragment>
      {driver && (
        <DriverProposeDialog
          open={driverProposeD}
          onClose={handleCloseDriverProposeD}
          driver={driver}
          refetch={refetch}
        />
      )}
      <List className={classes.root}>
        {status === 'confirmedDriver' ? (
          <ListItem
            disabled={loadingActions.deselectDriver}
            button
            onClick={handleDeselectDriver}
          >
            <ListItemIcon>
              <RemoveCircleIcon />
            </ListItemIcon>
            <ListItemText primary="عدم انتخاب" />
            {loadingActions.deselectDriver && (
              <CircularProgress size={'15px'} />
            )}
          </ListItem>
        ) : null}
        {status === 'selectedDriver' ? (
          <Fragment>
            <ListItem
              disabled={loadingActions.confirmDriver}
              button
              onClick={handleConfirmDriver}
            >
              <ListItemIcon>
                <FlagIcon />
              </ListItemIcon>
              <ListItemText primary="تائید نهایی راننده برای سفارش" />
              {loadingActions.confirmDriver && (
                <CircularProgress size={'15px'} />
              )}
            </ListItem>
            <ListItem
              disabled={loadingActions.deselectPropose}
              button
              onClick={handleDeselectPropose}
            >
              <ListItemIcon>
                <RemoveCircleIcon />
              </ListItemIcon>
              <ListItemText primary="عدم تائید پیشنهاد راننده" />
              {loadingActions.deselectPropose && (
                <CircularProgress size={'15px'} />
              )}
            </ListItem>
          </Fragment>
        ) : null}
        {status === 'driverProposed' ? (
          <Fragment>
            <ListItem
              button
              disabled={loadingActions.selectUser}
              onClick={handleSelectDriver}
            >
              <ListItemIcon>
                <FlagIcon />
              </ListItemIcon>
              <ListItemText primary="انتخاب راننده" />
              {loadingActions.selectUser && <CircularProgress size={'15px'} />}
            </ListItem>
            <ListItem button onClick={handleShowDriverProposeD}>
              <ListItemIcon>
                <MonetizationOnIcon />
              </ListItemIcon>
              <ListItemText primary="تغییر پیشنهاد راننده" />
            </ListItem>
          </Fragment>
        ) : null}
        {status === 'waitingForDriverBid' ? (
          <Fragment>
            <ListItem button onClick={handleShowDriverProposeD}>
              <ListItemIcon>
                <MonetizationOnIcon />
              </ListItemIcon>
              <ListItemText primary="ثبت پیشنهاد حمل بار راننده" />
            </ListItem>
            <ListItem
              button
              disabled={loadingActions.deleteUser}
              onClick={handleDeleteDriver}
            >
              <ListItemIcon>
                <DeleteIcon />
              </ListItemIcon>
              <ListItemText primary="حذف از لیست" />
              {loadingActions.deleteUser && <CircularProgress size={'15px'} />}
            </ListItem>
          </Fragment>
        ) : null}
        {status === 'driverProposed' ? (
          <ListItem
            button
            disabled={loadingActions.deleteUser}
            onClick={handleDeleteDriver}
          >
            <ListItemIcon>
              <FlagIcon />
            </ListItemIcon>
            <ListItemText primary="حذف از لیست" />
            {loadingActions.deleteUser && <CircularProgress size={'15px'} />}
          </ListItem>
        ) : null}
      </List>
    </Fragment>
  );
};

export default React.memo(BiddersCommandsList);
